var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeOpacity: 0.5,
    stroke: "#505F79",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#505F79",
    transform: "translate(10.000000, 10.000000) rotate(45.000000) translate(-10.000000, -10.000000) ",
    points: "10.75 6 10.75 9.25 14 9.25 14 10.75 10.749 10.75 10.75 14 9.25 14 9.249 10.75 6 10.75 6 9.25 9.25 9.25 9.25 6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNormal);
export default __webpack_public_path__ + "static/media/Close_Normal.9950a11e0f5f08368a48950d983fcfc6.svg";
export { ForwardRef as ReactComponent };